export default class StorageService {
  static STORAGE_SESSION = "session";
  static STORAGE_LOCAL = "local";
  static local = window.localStorage;
  static session = window.sessionStorage;

  public static save(key: string, value: any, storageType: string = this.STORAGE_SESSION) {
    return window[storageType + "Storage"].setItem(key, JSON.stringify(value));
  }
  public static remove(key: string, storageType: string = this.STORAGE_SESSION) {
    return window[storageType + "Storage"].removeItem(key);
  }
  public static get(key: string, storageType: string = this.STORAGE_SESSION) {
   
    let value = window[storageType + "Storage"].getItem(key);
    if(value && value !== "undefined"){
      return JSON.parse(value);
    }else{
      return value;
    }
    
  }
}
